import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "form", "giverName", "street", "city", "state", "zip", "country", "invitationId", "submitButton", "errorMessage", "errorText"]
  static values = {
    updateUrl: String
  }

  open(event) {
    event.preventDefault()

    const button = event.currentTarget
    const giverName = button.dataset.giverName
    const invitationId = button.dataset.invitationId
    const street = button.dataset.street || ""
    const city = button.dataset.city || ""
    const state = button.dataset.state || ""
    const zip = button.dataset.zip || ""
    const country = button.dataset.country || "USA"

    if (this.hasGiverNameTarget) this.giverNameTarget.textContent = giverName
    if (this.hasInvitationIdTarget) this.invitationIdTarget.value = invitationId
    if (this.hasStreetTarget) this.streetTarget.value = street
    if (this.hasCityTarget) this.cityTarget.value = city
    if (this.hasStateTarget) this.stateTarget.value = state
    if (this.hasZipTarget) this.zipTarget.value = zip
    if (this.hasCountryTarget) this.countryTarget.value = country

    this.hideError()
    this.modalTarget.classList.remove("hidden")
    this.modalTarget.setAttribute("aria-modal", "true")
    document.body.classList.add("overflow-hidden")

    setTimeout(() => this.streetTarget?.focus(), 100)
  }

  close(event) {
    if (event) event.preventDefault()
    this.modalTarget.classList.add("hidden")
    this.modalTarget.removeAttribute("aria-modal")
    document.body.classList.remove("overflow-hidden")
  }

  closeOnBackdrop(event) {
    if (event.target === this.modalTarget) {
      this.close()
    }
  }

  async submit(event) {
    event.preventDefault()
    this.hideError()

    const invitationId = this.invitationIdTarget.value
    const formData = new FormData()
    formData.append("invitation[street_address]", this.streetTarget.value)
    formData.append("invitation[city]", this.cityTarget.value)
    formData.append("invitation[state]", this.stateTarget.value)
    formData.append("invitation[zip_code]", this.zipTarget.value)
    formData.append("invitation[country]", this.countryTarget.value)
    formData.append("invitation_id", invitationId)

    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = true
      this.submitButtonTarget.textContent = "Saving..."
    }

    try {
      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

      const response = await fetch(this.updateUrlValue, {
        method: "PATCH",
        headers: {
          "X-CSRF-Token": csrfToken,
          "Accept": "application/json"
        },
        body: formData
      })

      const data = await response.json()

      if (data.success) {
        window.location.reload()
      } else {
        this.showError("Failed to save address: " + (data.errors?.join(", ") || "Unknown error"))
      }
    } catch (error) {
      console.error("Error saving address:", error)
      this.showError("Failed to save address. Please try again.")
    } finally {
      if (this.hasSubmitButtonTarget) {
        this.submitButtonTarget.disabled = false
        this.submitButtonTarget.textContent = "Save Address"
      }
    }
  }

  showError(message) {
    if (this.hasErrorMessageTarget) {
      if (this.hasErrorTextTarget) {
        this.errorTextTarget.textContent = message
      } else {
        this.errorMessageTarget.textContent = message
      }
      this.errorMessageTarget.classList.remove("hidden")
    }
  }

  hideError() {
    if (this.hasErrorMessageTarget) {
      this.errorMessageTarget.classList.add("hidden")
    }
  }

  closeOnEscape(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }
}
